module.exports = __webpack_public_path__ + "static/media/2-en.15557ba0.svg";